
/**
 * Returns a copy of the specified object by deeply cloning all of its properties.
 */
export function deepCopy<T>(object: T): T {
    const refsCopied: {}[] = [];

    function copyRecurse(obj: T | null): T | null {
        let result: T | null = null;

        if (obj) {
            if (Array.isArray(obj)) {
                // @ts-ignore
                result = [];
            } else {
                // create clone of the object with same prototype chain
                result = Object.create(Object.getPrototypeOf(obj));
            }

            // iterate over all the properties in the object
            (<(keyof T)[]>Object.keys(obj)).forEach((key: keyof T) => {
                // recursively copy the object's properties if the property is an object
                const value = obj[key];
                if (typeof value === 'object') {
                    // @ts-ignore
                    if (refsCopied.indexOf(value) !== -1) {
                        throw new Error(
                            `Cannot perform DeepCopy() because a circular reference was encountered, object: ${obj}, property: ${key}`
                        );
                    }
                    // @ts-ignore
                    refsCopied.push(value);
                    // @ts-ignore
                    result[key] = copyRecurse(value);
                    refsCopied.pop();
                } else {
                    // @ts-ignore
                    result[key] = value;
                }
            });
        }
        return result;
    }

    return <T>copyRecurse(object);
}
